import styled, { keyframes } from 'styled-components';
import Typography from '../../typography/Typography';
const rotate = keyframes `
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    `;
export const SwapProgressBarContainer = styled.div `
  position: relative;

  display: flex;
  justify-content: space-between;
  width: 100%;

  background-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
  border-color: ${({ theme }) => theme.colors.surface.interactiveDefault};
`;
export const ProgressLine = styled.div `
  position: absolute;
  top: 50%;
  left: 0;
  width: 100%;
  height: 0.1rem;

  background-image: linear-gradient(
    to right,
    ${({ theme }) => theme.colors.borders.default} 0.8rem,
    transparent 0.6rem
  );

  background-size: 10px 1px; /* Set the total size of each dash and gap */
`;
export const StepWrapper = styled.div `
  position: relative;

  background-color: inherit;

  border-color: inherit;
`;
export const CircleImg = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;

  height: 3.4rem;
  width: 3.4rem;

  border-width: 0.2rem;
  border-style: solid;
  border-color: ${({ theme, hasPassed, hasFailed, isPending }) => {
    if (hasFailed) {
        return theme.colors.text.interactive;
    }
    if (isPending) {
        return 'transparent';
    }
    if (hasPassed) {
        return theme.colors.borders.highlight;
    }
    return theme.colors.borders.default;
}};

  border-radius: ${({ theme }) => theme.borderRadius.highest};

  background: ${({ theme, hasPassed, hasFailed, isPending }) => {
    if (hasFailed) {
        return theme.colors.interactive.critical;
    }
    if (isPending) {
        return theme.colors.surface.default;
    }
    if (hasPassed) {
        return theme.colors.interactive.brandColor;
    }
    return theme.colors.surface.default;
}};
`;
export const SwapStepTitle = styled(Typography) `
  position: absolute;
  top: 100%;
  left: 50%;
  text-wrap: nowrap;
  width: min-content;
  white-space: pre-line;
  text-align: center;
  transform: translate(-50%, 0.4rem);
  ${({ theme }) => theme.media.tabletS `
    width: unset;
    white-space: pre;
  `}
`;
export const Loader = styled.div `
  display: ${({ isPending }) => (isPending ? 'grid' : 'none')};

  position: absolute;
  top: 0;

  height: 3.4rem;
  width: 3.4rem;

  border: 0.2rem solid ${({ theme }) => theme.colors.interactive.brandColor};
  border-bottom-color: inherit;
  border-radius: ${({ theme }) => theme.borderRadius.highest};

  animation: ${rotate} 2s linear infinite;
`;
export const Line = styled.div `
  height: 0.4rem;
  width: calc(100% + 4.4rem);

  background-color: ${({ theme }) => theme.colors.surface.default};

  box-shadow: 0px 3px 4px 0px rgba(0, 0, 0, 0.25) inset;

  margin: 3.2rem -2.2rem 6.2rem;

  ${({ theme }) => theme.media.tabletM `
    width: calc(100% + 6.4rem);

    margin: 3.6rem -3.2rem 5.4rem;
  `}
`;
//# sourceMappingURL=styles.js.map